// Only reuse stored original references. Never derive an original from a preview URL.
export const productionFiles = (item) => {
    const slots = item.personalizationMetadata?.slots
    const originals = item.personalizationAssets?.originalUrls
    const valid = (url) => {
        if (typeof url !== 'string') return null
        try {
            const parsed = new URL(url)
            return parsed.protocol === 'https:' && !parsed.username && !parsed.password ? url : null
        } catch (_) { return null }
    }
    if (Array.isArray(slots) && slots.length) {
        return slots.map((slot, index) => ({ label: slot.slotId || `${index + 1}`, url: valid(slot.originalUrl) }))
    }
    return Array.isArray(originals) && originals.length
        ? originals.map((url, index) => ({ label: `${index + 1}`, url: valid(url) }))
        : [{ label: '1', url: null }]
}
